import React from "react";
import { getQuoteChecklistItems } from "./selectQuoteChecklistItems";

/**
 * "Before you continue" — the SELECT ORDER/SELL QUOTE section's mandatory
 * checklist (Alex, 2026-08-19). Purely informational ("warn but allow"): it
 * never disables Save/Next — the amber bar tells the rep what's still open
 * and what it blocks downstream, but advancing stays possible for the edge
 * cases where a listing is created later.
 *
 * The items themselves live in selectQuoteChecklistItems.js, shared with the
 * left rail's current-step mini-checklist so the two can never disagree.
 */
export function SelectQuoteChecklist({ request, selectedQuote, isPxSellSlot }) {
  const isOrder = request?.request_type === "order";
  const items = getQuoteChecklistItems(request, selectedQuote, isPxSellSlot);
  const remaining = items.filter((i) => !i.done).length;

  return (
    <div className="sq-checklist" data-testid="select-quote-checklist">
      <div className="sq-checklist__head">
        <h4>Before you continue</h4>
        <span className="sq-checklist__count">
          {remaining === 0 ? (
            <em>All done</em>
          ) : (
            <>
              <b>{remaining} left</b> · {items.length - remaining} of {items.length} done
            </>
          )}
        </span>
      </div>
      <ul>
        {items.map((item) => (
          <li key={item.key} className={item.done ? "is-done" : "is-todo"}>
            <span className="sq-checklist__mark" aria-hidden>
              {item.done ? "✓" : ""}
            </span>
            <span className="sq-checklist__body">
              <span className="sq-checklist__label">
                {item.label}
                {item.or && <span className="sq-checklist__or">{item.or}</span>}
              </span>
              <span className="sq-checklist__detail">{item.detail}</span>
            </span>
          </li>
        ))}
      </ul>
      {remaining > 0 && (
        <div className="sq-checklist__warn" role="status">
          <span aria-hidden>⚠️</span>
          <span>
            <b>This step isn&apos;t finished</b> — you can still continue, but the
            {isOrder && !isPxSellSlot
              ? " order can't reach payment"
              : " deal can't move on"}{" "}
            until everything above is done.
          </span>
        </div>
      )}
    </div>
  );
}
